var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mt-4"},[_c('div',{staticClass:"card col-12"},[_c('div',{staticClass:"mt-4"},[_c('iframe',{staticStyle:{"width":"100%","min-height":"calc(100vh - 170px)"},attrs:{"src":_vm.iframeUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }